import { gql, TypedDocumentNode } from '@apollo/client'
import { ItemType } from '../../inventory/type/item'
import {
  CreateFilterOverrideInput,
  FilterBaseConfigEntryView,
  FilterDescriptorView,
  FilterOverrideView,
  SaveBaseConfigInput,
  UpdateFilterOverrideInput,
} from '../type/filter-config'

export const GetFilterCatalog: TypedDocumentNode<
  { filterCatalog: FilterDescriptorView[] },
  Record<string, never>
> = gql`
  query FilterCatalog {
    filterCatalog {
      key
      label
      kind
    }
  }
`

export const GetFilterBaseConfig: TypedDocumentNode<
  { filterBaseConfig: FilterBaseConfigEntryView[] },
  { productType: ItemType }
> = gql`
  query FilterBaseConfig($productType: ItemType!) {
    filterBaseConfig(productType: $productType) {
      filterKey
      label
      kind
      enabled
      displayOrder
    }
  }
`

export const GetFilterOverridesByType: TypedDocumentNode<
  { filterOverridesByType: FilterOverrideView[] },
  { productType: ItemType }
> = gql`
  query FilterOverridesByType($productType: ItemType!) {
    filterOverridesByType(productType: $productType) {
      id
      productType
      scopeType
      scopeId
      name
      target {
        id
        title
        breadcrumb
      }
      rules {
        id
        filterKey
        action
        displayOrder
      }
    }
  }
`

export const GetFilterOverride: TypedDocumentNode<
  { filterOverride: FilterOverrideView | null },
  { id: number }
> = gql`
  query FilterOverride($id: Int!) {
    filterOverride(id: $id) {
      id
      productType
      scopeType
      scopeId
      name
      target {
        id
        title
        breadcrumb
      }
      rules {
        id
        filterKey
        action
        displayOrder
      }
    }
  }
`

export const SaveFilterBaseConfig: TypedDocumentNode<
  { filterBaseConfigSave: void },
  { input: SaveBaseConfigInput }
> = gql`
  mutation SaveFilterBaseConfig($input: SaveBaseConfigInput!) {
    filterBaseConfigSave(input: $input)
  }
`

export const CreateFilterOverride: TypedDocumentNode<
  { filterOverrideCreate: FilterOverrideView },
  { input: CreateFilterOverrideInput }
> = gql`
  mutation CreateFilterOverride($input: CreateFilterOverrideInput!) {
    filterOverrideCreate(input: $input) {
      id
      productType
      scopeType
      scopeId
      name
      rules {
        id
        filterKey
        action
        displayOrder
      }
    }
  }
`

export const UpdateFilterOverride: TypedDocumentNode<
  { filterOverrideUpdate: FilterOverrideView },
  { input: UpdateFilterOverrideInput }
> = gql`
  mutation UpdateFilterOverride($input: UpdateFilterOverrideInput!) {
    filterOverrideUpdate(input: $input) {
      id
      productType
      scopeType
      scopeId
      name
      rules {
        id
        filterKey
        action
        displayOrder
      }
    }
  }
`

export const DeleteFilterOverride: TypedDocumentNode<void, { id: number }> = gql`
  mutation DeleteFilterOverride($id: Int!) {
    filterOverrideDelete(id: $id)
  }
`
